import {Typography} from 'components/Typography';
import {DetailedCharacteristicsListContent} from 'modules/product-card/components/DetailedCharacteristicsListContent';
import {FC} from 'react';
import style from './style.module.scss';
import classNames from 'classnames';
import {IResultCharacteristicData} from 'modules/product-card/helpers/characteristics';

interface IProps {
    detailedCharacteristics: IResultCharacteristicData[];
    tabletCharacteristics?: IResultCharacteristicData[];
}

export const DetailedCharacteristicsList: FC<IProps> = ({detailedCharacteristics, tabletCharacteristics = []}) => {
    return (
        <div className={style.main}>
            <Typography className={style.title} variant={'title-18-m'}>
                Параметры
            </Typography>
            <div className={classNames(style.content, style.desktop)}>
                {detailedCharacteristics.map(({dataList, titleList}) => {
                    const title = titleList.join(', ');

                    return <DetailedCharacteristicsListContent dataList={dataList} key={title} title={title} />;
                })}
            </div>
            {0 < tabletCharacteristics.length && (
                <div className={classNames(style.content, style.tablet)}>
                    {tabletCharacteristics.map(({dataList, titleList}) => {
                        const title = titleList.join(', ');

                        return <DetailedCharacteristicsListContent dataList={dataList} key={title} title={title} />;
                    })}
                </div>
            )}
        </div>
    );
};
